class RenderResults extends HTMLElement { 
  constructor() { 
    super()
    this.contentType = null
    this.settings = JSON.parse(this.querySelector('script').textContent)
    this.container = this.querySelector('.results')
    this.loader = this.querySelector('.results__loader')
    this.loading = document.querySelector('.loading-dots')
    this.firstLoaded = document.querySelector('.filter__first-loaded')
    this.empty = this.querySelector('.results__empty')
    this.filterContentTypes = document.querySelector('.filter-drawer__content-types') || null
    this.filterHTML = null
    this.resetPage = false
    this.isFilter = false
    this.searchParams = new URLSearchParams(window.location.search)
    if(this.settings.infiniteLoad) { 
      if(!this.searchParams.has('content_type') || this.searchParams.get('content_type') === 'all') { 
        this.classList.remove('loading')
      }  
    }
    if(!this.settings.infiniteLoad && this.filterContentTypes) { 
      this.filterContentTypes.classList.add('hidden')
    }
    document.addEventListener('filterUpdate', this.onFilterChange.bind(this))
  }
  connectedCallback() {
    if(this.settings.infiniteLoad) {
      this.loading.classList.remove('hidden')
      this.getInitialResults().then(() => {
        if(this.results < this.settings.paginateBy*2) {
          this.updateCounts();
          this.loading.classList.add('hidden')
          return
        }
        if(this.results.length > this.settings.paginateBy*2) { 
          this.firstLoaded.classList.remove('hidden')
        }
        this.getRemainingResults().then(() => { 
          if(this.filterContentTypes) {
            this.onLoad()
          }
        })
        // this.toggleState()
        this.onIntersectionObserver()
      }) 
    }
  }
  async onLoad() { 
    if(this.searchParams.has('content_type')) { 
      // filter and reload results
      this.contentType = this.searchParams.get('content_type')
      if(this.contentType !== 'all') {
        const filteredResults = this.filterByType(this.contentType)
        this.classList.remove('loading')
        this.nextElementSibling.classList.add('hidden')
        this.updateActiveType()
        this.updateTotalCount(filteredResults)
        // update active type 

        if(filteredResults.length > 0) { 
          this.renderResults(filteredResults, true)
        } else { 
          this.renderNoResults()
        }
      }
    }
  }
  async getInitialResults(page) { 
    let maxPages = 2
    if(page) { 
      maxPages = page
    }
    const fetchUrls = [];
    for (let currentPage = 1; currentPage <= maxPages; currentPage++) {
      const url = this.createUrl(currentPage, this.dataset.url)
      const fetchURL = `${url.pathname}${url.search}`
      fetchUrls.push(fetchURL)
    }
    const results = await this.fetchPromises(fetchUrls, true) 
    this.results = results
  }
  async getRemainingResults(page) { 
    let fetchUrls = []
    const totalPages = Math.ceil(this.settings.totalResults/this.settings.paginateBy)
    let minPages = page ? page : 3
    
    if(totalPages < minPages) { 
      this.loading.classList.add('hidden')
      this.updateTotalCount(null)
      this.updateCounts()
      return
    }
    for (let currentPage = minPages; currentPage <= totalPages; currentPage++) {
      const url = this.createUrl(currentPage, this.dataset.url)
      const fetchURL = `${url.pathname}${url.search}`
      fetchUrls.push(fetchURL)
    }
    const results = await this.fetchPromises(fetchUrls, false) 
    this.results = this.results.concat(results)
    this.loading.classList.add('hidden')
    this.updateCounts()
  }
  async fetchPromises(fetchUrls, isInitial) { 
    const fetchPromises = fetchUrls.map((url) => fetch(url))
    return Promise.all(fetchPromises).then((responseArr) => Promise.all(responseArr.flat().map((response) => { 
      if(!response.ok) { 
        throw new Error(`This are only ${response.length} total`);
      }
      return response.text()
    })))

    .then((texts) => { 
      let resultsArr = []
      for(let i = 0; i < texts.length; i++) { 
        const text = texts[i]
        const container = new DOMParser().parseFromString(text, 'text/html').querySelector('.results')

        // // Update Active Filters
        if (text[0] && isInitial) {
          this.filterHTML = new DOMParser().parseFromString(text, 'text/html');
        }

        if(container.children.length === 0) { 
          this.checkResults = false
          break
        }
        const items = container.querySelectorAll('.results__item')
        resultsArr.push(...items)
      }
      return resultsArr
    })
  }
  async onFilterChange(event) { 
    this.typeChange = event.detail.typeChange
    this.isFilter = event.detail.isFilter
    this.contentType = event.detail.contentType

    if(this.typeChange) { 
      const filteredResults = this.filterByType(null)
      // this.toggleState()
      if(filteredResults.length > 0) {
        this.empty.classList.add('hidden') 
        this.renderResults(filteredResults,true)
        // this.toggleState()
      } else { 
        this.renderNoResults()
      }
      this.updateTotalCount(filteredResults)
    } else { 
      if(this.settings.infiniteLoad) {
        try {
          this.loading.classList.remove('hidden')
          await this.getInitialResults();
          const filteredResults = this.filterByType(null)

          // update contentType to all and select as active
          if(this.filterHTML) { 
            this.renderFilters(this.filterHTML)
          }
      

          if(filteredResults.length === 0) { 
            this.renderNoResults()
          } else {
            this.empty.classList.add('hidden') 
            this.renderResults(filteredResults, true);
          }

          if(this.results.length < this.settings.paginateBy*2) {
            this.updateCounts();
            this.loading.classList.add('hidden')
            this.firstLoaded.classList.add('hidden')
            return
          } 

          // this.firstLoaded.classList.remove('hidden')
          await this.getRemainingResults();

          this.loading.classList.add('hidden')
          this.onIntersectionObserver()
        } catch (error) {
          console.error('Error during filter change:', error);
        }
      } else { 
        this.renderPaginatedResults()
      }
    }
  }
  async updateCounts() { 
    this.updateTypeCount()
    this.updateTotalCount(null)
  }
  renderPaginatedResults() { 
    let url = this.createUrl(null, this.dataset.url)
    const fetchURL = `${url.pathname}${url.search}`;
    fetch(fetchURL).then(response => response.text())
    .then(text => { 
      const container = new DOMParser().parseFromString(text, 'text/html').querySelector(`[data-section="${this.dataset.section}"]`)
      const results = container.querySelector('.results')

      // Render pagination and filters
      this.renderPagination(container) 
      this.renderFilters(container)

      // Update count
      const totalCount = parseInt(container.querySelector('.results__count').innerHTML)
      const countContainer = document.querySelectorAll('[data-total-count]')
      countContainer.forEach(count => count.innerHTML = totalCount)      

      // Render results
      if(totalCount > 0) { 
        this.empty.classList.add('hidden')
        this.container.innerHTML = results.innerHTML
      } else { 
        this.renderNoResults()
      } 
    }).catch((error => { 
      console.log(error)
    }))
  }
  renderPagination(html) { 
    const pagination = html.querySelector('.pagination-wrapper') || null
    const paginationContainer = document.querySelector('.pagination-wrapper')

    if(paginationContainer === null || paginationContainer === undefined) { 
      return
    }
    if(pagination === null || pagination === undefined) { 
      paginationContainer.classList.add('hidden')
      paginationContainer.innerHTL = ''
    } else { 
      paginationContainer.classList.remove('hidden')
      paginationContainer.innerHTML = pagination.innerHTML
    }
  }
  renderFilters(html) { 
    const activeFilters = html.querySelector('.results__filters') || null
    const activeFiltersContainer = document.querySelector('.active-filters')
    if(activeFilters.children.length > 0) { 
      activeFiltersContainer.innerHTML = activeFilters.innerHTML
      activeFiltersContainer.classList.remove('hidden')
      document.documentElement.style.setProperty('--scrollbar-padding', `${activeFiltersContainer.getBoundingClientRect().height + 50}px`);
    } else { 
      activeFiltersContainer.innerHTML = ''
      activeFiltersContainer.classList.add('hidden')
    }
  }
  renderNoResults() { 
    this.empty.classList.remove('hidden')
    this.container.innerHTML = ''
    // this.toggleState()
    return
  }
  renderResults(arr, load) { 
    let results = arr !== null ? arr : this.results
    if(load) { 
      this.container.innerHTML = ''
      results = results.slice(0, parseInt(this.settings.paginateBy))
    }
    results.forEach((result) => { 
      const styledResult = this.styleResult(result)
      this.container.appendChild(styledResult)
      generateBorders()
    })
  }
  getNextResults() { 
    const filteredResults = this.filterByType(null)
    let totalResults = this.container.querySelectorAll('.results__item').length
    const adverts = this.container.querySelectorAll('.advert')
    totalResults = totalResults - adverts.length
  
    let startIndex = totalResults
    let endIndex = startIndex + this.settings.postsToLoad    
    const renderedResults = []; 
    
    if(startIndex < filteredResults.length) {
      const nextResults = filteredResults.slice(startIndex, endIndex);
      renderedResults.push(...nextResults); 
      startIndex += this.settings.postsToLoad;
      endIndex += this.settings.postsToLoad;
    }
    // Stop from loading more posts
    if(filteredResults.length === 0) { 
      return 
    }

    this.loadInitial = false;
    this.renderResults(renderedResults);

    if (startIndex <= filteredResults.length) {
      if (this.onIntersectionObserver && this.onIntersectionObserver.observer) {
        this.onIntersectionObserver.observer.disconnect();
        return
      }
    }
  }
  styleResult(result) { 
    // custom styles go here 
    return result
  }
  createUrl(pageNum, baseURL) { 
    const url = new URL(baseURL, document.baseURI)
    // checks if there are existing params and updates URL
    const existingParams = new URLSearchParams(window.location.search)
    if(existingParams) { 
      existingParams.forEach((key,value) => { 
        url.searchParams.set(value, key)
      })
      if(this.resetPage && this.isFilter) { 
        url.searchParams.delete('page')
        window.history.replaceState({}, '', `?${url.searchParams.toString()}`)  
      }
    }
    // Dynamically update URL if infinite load is enabled
    if(this.settings.infiniteLoad) { 
      url.searchParams.set('section_id',this.dataset.section)
      url.searchParams.set('page', pageNum)
    }
    return url
  }
  onIntersectionObserver() { 
    let initialIntersecting = false
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.getNextResults();
          initialIntersecting = true;

        }
      }
    })
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2, 
    }

    if(this.loader !== null || this.loader != undefined) {
      observer.observe(this.loader, options);

      if (initialIntersecting && !this.loadingNextResults) {
        this.getNextResults();
      }
    }
  }
  updateTypeCount() { 
    const types = document.querySelectorAll('input[name="content_type"]')
    types.forEach(type => { 
      const contentType = type.value
      const typeArr = this.filterByType(contentType)
      const count = type.parentElement.querySelector('[data-content-count]')
      if(contentType === 'all') { 
        count.innerHTML = this.results.length
      } else { 
        count.innerHTML = typeArr.length
      }
    })
  }
  updateTotalCount(arr) { 
    const results = arr !== null ? arr : this.results
    const totalCount = document.querySelectorAll('[data-total-count]')
    totalCount.forEach(count => { 
      count.innerHTML = results.length
    })
  }
  updateActiveType() { 
    const types = document.querySelectorAll('input[name="content_type"]')
    types.forEach((type) => { 
      type.checked = false
      if(type.value === this.contentType) { 
        type.checked = true
      }
    })
  }
  filterByType(type) { 
    const results = this.results
    const contentType = type !== null ? type : this.contentType
    if (contentType === null || contentType === undefined || contentType === 'all') {
      return results;
    } else {
      const filteredResults = results.filter(item => item.dataset.contentType === contentType);
      return filteredResults;
    }    
  }
  toggleState() { 
    const types = document.querySelectorAll('filter-new input[type="number"], filter-new input[type="radio"]')
    types.forEach(type => { 
      if(type.hasAttribute('disabled')) {
        type.removeAttribute('disabled')
      } else { 
        type.setAttribute('disabled', '')
      }
    })
  }
}
customElements.define('test-results', RenderResults)

class MainSearch extends RenderResults { 
  constructor() { 
    super()
    this.resetPage = true
  }
  styleResult(result) { 
    return result
  }
}
customElements.define('main-search', MainSearch)

class MainCollection extends RenderResults { 
  constructor() { 
    super()
    this.resetPage = true
  }
  styleResult(result) { 
    const productCard = result.querySelector('.product-card__container')
    const vendor = result.querySelector('.product-card__vendor')
    this.settings.full_width ? result.classList.add('full-width') : result.classList.remove('full-width')
    this.settings.show_background ? productCard.classList.remove('no-background') : productCard.classList.add('no-background')
    this.settings.show_vendor ? vendor.classList.remove('hidden') : vendor.classList.add('hidden')
    return result
  }
}
customElements.define('main-collection', MainCollection)


class BlogPosts extends RenderResults { 
  constructor() { 
    super()
  }
  styleResult(result) { 
    const main = result.querySelector('.blog-post__main')
    const image = result.querySelector('.blog-post__image')
    const container = result.querySelector('.blog-post__container')

    // container background (posts with no image)
    this.settings.showContainer && image === null ? main.classList.add('container--bg') : main.classList.remove('container--bg')

    // full width
    this.settings.fullWidth ? result.classList.add('full-width') : result.classList.remove('full-width')

    // Image as background
    if(this.settings.imageAsBackground && image !== null) { 
      main.classList.add('has-image')
      container.classList.add('absolute')
    }
    // remove existing aspect-ratio class
    if(image !== null) {
      for(let cls of image.classList) { 
        if(cls.includes('aspect-')) { 
          image.classList.remove(cls)
        }
      }
      // add aspect ratio
      image.classList.add(this.settings.aspectRatio)
       // image overlay
      this.settings.showOverlay ? image.classList.add('image--overlay') : image.classList.remove('image--overlay')
    }
    // List style
    if(this.settings.postsPerRow === 1) { 
      main.classList.add('grid')
      main.classList.add('grid-cols-4')
      if(image !== null) { 
        image.classList.add('grid-col-1')
        container.classList.add('grid-col-2-span-2')
      }
    }
 
    return result
  }
  createUrl(pageNum, baseURL) { 
    // Check baseURL for tags
    if(this.settings.filterTags !== null) { 
      const filterTags = this.settings.filterTags.split(',')
      const tagPath = filterTags.join('+')
      baseURL = `${baseURL}/tagged/${tagPath}`
    }

    // Setup URL 
    const url = new URL(baseURL, document.baseURI)
    url.searchParams.set('section_id',this.dataset.section)

    // Checks to see there are existing params and updates URL
    const existingParams = new URLSearchParams(window.location.search)
    if(existingParams) { 
      existingParams.forEach((key,value) => { 
        url.searchParams.set(value, key)
      })
    }
    url.searchParams.set('page', pageNum)
    return url
  }
}
customElements.define('blog-posts', BlogPosts)